import * as v from "valibot";

import { rpcContract } from "../rpc";

export const verifyWaitingListEmailRpcContract = rpcContract({
  name: "verify-waiting-list-email",
  paramsSchema: v.object({
    email: v.pipe(v.string(), v.email("Invalid email format")),
    token: v.pipe(v.string(), v.minLength(1, "Token is required")),
    handle: v.pipe(v.string(), v.minLength(3), v.maxLength(64)),
  }),
  resultSchema: v.object({
    success: v.boolean(),
  }),
});

export type VerifyWaitingListEmailParams = v.InferOutput<(typeof verifyWaitingListEmailRpcContract)["paramsSchema"]>;
export type VerifyWaitingListEmailResult = v.InferOutput<(typeof verifyWaitingListEmailRpcContract)["resultSchema"]>;
